// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "./js/" + ({"388":"result","864":"message-page","962":"home"}[chunkId] || chunkId) + "." + {"46":"01bf7929","73":"5d7aa13d","388":"8da2a384","752":"fae00417","864":"60d1d787","962":"d893f10b"}[chunkId] + ".js";
};